/* =========== = = = Announcemet bar = = = ============================= */
document.addEventListener("DOMContentLoaded", function () {
  const announceBar = document.querySelector(".spl-announcebar");
  const target = document.documentElement; // or use document.body

  function updateAnnounceBarHeight() {
    if (announceBar) {
      let height = announceBar.offsetHeight;
      target.style.setProperty("--announcement-bar-height", height + "px");
    }
  }

  // Run on load
  updateAnnounceBarHeight();

  // Update on resize
  window.addEventListener("resize", updateAnnounceBarHeight);
});
/* =========== = = = =============== = = = ============================== */

// HERO SLIDER -- START

$(document).ready(function(){
  $('.hero_slider_wrapper').slick({
    dots: true,
    infinite: false,
    fade: true,
    autoplay: true,
    arrows: false,
    speed: 400,
    slidesToShow: 1
  });
});


// HERO SLIDER -- END

document.addEventListener('DOMContentLoaded', () => {
  const menuDetails = document.getElementById('Details-menu-drawer-container');
  const closeBtn = document.querySelector('.mdh-close');

  if (menuDetails) {
    // Handle open/close via <summary>
    menuDetails.addEventListener('toggle', () => {
      if (menuDetails.hasAttribute('open')) {
        document.body.classList.add('menu-open');
      } else {
        document.body.classList.remove('menu-open');
        document.body.classList.remove('overflow-hidden-tablet');
      }
    });
  }

  if (closeBtn) {
    // Handle click on custom close button
    closeBtn.addEventListener('click', () => {
      menuDetails.removeAttribute('open'); // close the drawer
      document.body.classList.remove('menu-open'); // remove body class
      document.body.classList.remove('overflow-hidden-tablet');
    });
  }
});
/*************************************************************
 * PRODUCT DETAILS PAGE ACCORDION START
*******************************************************/  

// Product page details accordian
$(document).on("click",".adv_panel_set > .adv_summary__title", function() {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this)
      .siblings(".adv_accordion__content")
      .slideUp(200);
    $(".adv_panel_set > .adv_summary__title span")
      .removeClass("fa-minus")
      .addClass("fa-plus");
  } else {
    $(".adv_panel_set > .adv_summary__title span")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    $(this)
      .find("span")
      .removeClass("fa-plus")
      .addClass("fa-minus");
    $(".adv_panel_set > .adv_summary__title").removeClass("active");
    $(this).addClass("active");
    $(".adv_accordion__content").slideUp(200);
    $(this)
      .siblings(".adv_accordion__content")
      .slideDown(200);
  }
});

/*************************************************************
 * PRODUCT DETAILS PAGE ACCORDION END
*******************************************************/  

/**********************************************************************************
 * COLLECTION PAGE PRODUCT POPUP IN SIZE GUIDE START 
********************************************************************************/  
// Open modal
jQuery(document).on("click",".product__info-container .button_sizeguide",function(){
  openModal();
});
// Close modal
jQuery(document).on("click",".size-guide-modal .size-guide-close",function(){
  closeModal();
});

// Close when clicking outside modal
$(window).on("click", function (e) {
  if($("#SizeGuideModal").length>0){
    var $modal = $("#SizeGuideModal");
    if (e.target === $modal[0]) {
      closeModal();
    }
  }
});

// Close on Esc key
$(window).on("keydown", function (e) {
  if($("#SizeGuideModal").length>0){
    var $modal = $("#SizeGuideModal");
    if (e.key === "Escape" && $modal.css("display") === "flex") {
      closeModal();
    }
  }
});
function openModal() {
  if($("#SizeGuideModal").length>0){
    var $modal = $("#SizeGuideModal");
    $modal.css("display", "flex");
    $("body").addClass("size-guide-open");
  }
}

function closeModal() {
  if($("#SizeGuideModal").length>0){
    var $modal = $("#SizeGuideModal");
    $modal.css("display", "none");
    $("body").removeClass("size-guide-open");
  }
}
/**********************************************************************************
 * COLLECTION PAGE PRODUCT POPUP IN SIZE GUIDE START 
********************************************************************************/  

/**********************************************************************************
 * Home page hero slider mobile height get js START
***********************************************************************************/ 
$(document).ready(function () {
  var $slider = $('.hero_slider_wrapper');
  function updateSlideHeight() {
    let wrapperHeight = $slider.outerHeight();
    $slider[0].style.setProperty('--slide-height', wrapperHeight + 'px');
  }
  $slider.on('init', function (event, slick) {
    updateSlideHeight();
  });
  $slider.on('setPosition', function (event, slick) {
    updateSlideHeight();
  });
  $slider.slick({
  });
});
/**********************************************************************************
 * Home page hero slider mobile height get js END
***********************************************************************************/ 

